import React, { useState } from 'react';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Collapse,
  Box,
} from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

export default function WorkerReview({ data }) {
  const [expanded, setExpanded] = useState(true);

  if (!data) {
    return null;
  }

  const workers = data;

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          p: 1,
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <IconButton size='small'>
          {expanded ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
        <Typography variant='h6'>Workers</Typography>
      </Box>
      <Collapse in={expanded}>
        <Paper sx={{ p: 2, mb: 2 }}>
          {workers.length > 1 ? (
            <TableContainer>
              <Table size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: '20%' }}>Worker</TableCell>
                    <TableCell>Command</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {workers.map((worker, i) => (
                    <TableRow key={i + 1}>
                      <TableCell>Worker {i + 1}</TableCell>
                      <TableCell>{worker.command}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography>
              Command: <b>{workers[0].command}</b>
            </Typography>
          )}
        </Paper>
      </Collapse>
    </Box>
  );
}

